import service from '@/api/index.js'

export const getHomeData = function (params) {
  return service({
    url: '/config',
    method: 'post',
    data: params,
  })
}

export const getNewsList = function (params, type) {
  return service({
    url: '/news/' + type,
    method: 'get',
    params: params,
  })
}

export const getNewsDetail = function (params, id) {
  return service({
    url: '/detail/' + id,
    method: 'get',
    params: params,
  })
}